var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$store.getters.userRole === 'top_agent')?_c('show-top-agent-self-subscribe-order'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }